

export default {
  namespaced: true,
  state: {
    comment: null
  },
  getters: {
    comment(state) {
      return state.comment
    },
  },
  actions: {
    setCommit({ commit }, payload) {
      commit('setComment', payload)
    },
  },
  mutations: {
    setComment(state, payload) {
      state.commit = payload
    },
  },
}
